import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delay = 0) {
  const [v, setV] = useState(value);
  useEffect(() => {
    if (!delay) {
      setV(value);
      return;
    }
    const t = setTimeout(() => setV(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return v;
}
